import _ from 'lodash';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from '@duxton-web/ui';

import {
  CREATE_JOURNEY_CAMPAIGN_GROUP,
  createJourneyCampaignGroup,
} from 'omega-rtc/actions/ucd';
import { snackBar } from 'omega-rtc/components/custom/SnackBar';
import ShowIfAuthorized from 'omega-rtc/components/form/ucd/common/ShowIfAuthorized';
import { UCD_ACTION_TYPES, UCD_RESOURCE_NAMES, UCD_ROUTES_LINK } from 'omega-rtc/constants/ucd';
import { getRequestStateKey } from 'omega-rtc/utils/ucd-utils';
import { UCDCreateJourneyCampaign } from 'omega-rtc/views/ucd/UCDCreateJourneyCampaign';
import type { CreateJourneyCampaignRequest } from 'omega-rtc/views/ucd/UCDCreateJourneyCampaign';

const CreateJourneyCampaignGroup = (props: any) => {
  const dispatch = useDispatch();
  const createRequest = useSelector((state: any) => _.get(
    state.requests,
    getRequestStateKey(CREATE_JOURNEY_CAMPAIGN_GROUP),
    {},
  ));
  const campaignGroupID = useSelector(
    (state: any) => state.ucd.newlyCreatedCampaignGroup,
  );
  const createError = useSelector(
    (state: any) => state.ucd.createJourneyCampaignGroupError,
  );
  const userEmail = useSelector((state: any) => _.get(state, 'app.user.email', ''));
  const previousRequest = useRef(createRequest);
  const isSubmitting = useRef(false);

  useEffect(() => {
    const wasPending = previousRequest.current.isPending;
    previousRequest.current = createRequest;

    if (!wasPending) {
      return;
    }

    if (createRequest.isSuccessful) {
      snackBar.success({ content: `Journey Campaign Group ${campaignGroupID} created successfully` });
      props.router.push(UCD_ROUTES_LINK.JOURNEY_CAMPAIGN_GROUP_VIEW(campaignGroupID));
    } else if (createRequest.isFailure) {
      isSubmitting.current = false;
      snackBar.error({ content: createError || 'Unable to create Journey Campaign Group' });
    }
  }, [campaignGroupID, createError, createRequest, props.router]);

  return (
    <UCDCreateJourneyCampaign
      onSubmit={(payload: CreateJourneyCampaignRequest) => {
        if (isSubmitting.current) {
          return;
        }

        if (!userEmail) {
          snackBar.error({ content: 'Unable to identify the current user. Please sign in again.' });
          return;
        }

        isSubmitting.current = true;
        dispatch(createJourneyCampaignGroup({ ...payload, user: userEmail }));
      }}
    />
  );
};

const AuthorizedCreateJourneyCampaignGroup = (props: any) => (
  <ShowIfAuthorized
    conditions={[{ resource: UCD_RESOURCE_NAMES.campaign, action: UCD_ACTION_TYPES.create }]}
    unauthorizedContent={(
      <Alert message="You don't have access to create Holos campaign" showIcon type="error" />
    )}
  >
    <CreateJourneyCampaignGroup {...props} />
  </ShowIfAuthorized>
);

export default AuthorizedCreateJourneyCampaignGroup;
